var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('HeroSmall',{attrs:{"data":_vm.hero}}),_c('div',{staticClass:"container"},[_c('DropDown',{attrs:{"data":_vm.buttons,"buttonText":"Event Actions"}})],1),_c('br'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }